module.exports = __webpack_public_path__ + "static/img/cont45_04.a131d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45_04.jpg
// module id = kZfj
// module chunks = 0